import { Link } from "react-router-dom";

export const PrivacyPage = () => {
  const lastUpdated = "April 2026";

  return (
    <div id="main-content" className="pt-20" data-testid="privacy-page">
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="overline text-brand-primary mb-4">Legal</p>
          <h1 className="font-serif text-4xl sm:text-5xl font-light text-slate-900 leading-tight mb-4">
            Privacy Policy
          </h1>
          <p className="text-sm text-slate-500 mb-10">Last updated: {lastUpdated}</p>

          <div className="prose-custom space-y-6 text-slate-700 leading-relaxed">
            <p>
              The Centre for Consciousness Studies Australia ("the Centre", "we", "our") is committed to
              protecting the privacy of individuals who interact with this website. This policy explains
              what information we collect, how it is used, and the choices available to you.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Information We Collect</h2>
            <p>
              We collect personal information only when it is voluntarily provided through our contact
              form. This may include your name, email address, organisation, the content of your enquiry,
              and any document you choose to attach (PDF, DOC, or DOCX, up to 5 MB).
            </p>
            <p>
              Our hosting infrastructure may automatically log standard technical data such as IP address,
              browser type, and pages visited for the purposes of security and basic analytics.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">How We Use Your Information</h2>
            <p>We use the information you provide to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Respond to your enquiry or request;</li>
              <li>Maintain records of our correspondence;</li>
              <li>Protect the website against spam and abuse;</li>
              <li>Comply with legal obligations where applicable.</li>
            </ul>
            <p>
              We do not sell, rent, or trade personal information with third parties. We do not use
              submissions for marketing purposes.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Data Retention</h2>
            <p>
              Enquiry submissions are retained for as long as necessary to address the matter raised and
              to meet reasonable record-keeping requirements. Attachments uploaded via the contact form
              are stored on secure infrastructure and may be deleted on request.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Your Rights</h2>
            <p>
              Under the Australian Privacy Principles and comparable frameworks, you have the right to
              request access to, correction of, or deletion of personal information we hold about you. To
              exercise these rights, please contact us using the details below.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Security</h2>
            <p>
              We take reasonable technical and organisational measures to protect information submitted
              through this site. However, no transmission over the internet can be guaranteed to be
              completely secure.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Changes to this Policy</h2>
            <p>
              We may update this policy from time to time. Material changes will be reflected on this
              page together with a revised "Last updated" date.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Contact</h2>
            <p>
              For privacy enquiries, please{" "}
              <Link to="/contact" className="text-brand-primary hover:underline">
                contact the Centre
              </Link>
              .
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
